export enum AssetSize {
  Thumb = 'Thumb',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  Original = 'Original',
  Null = ''
}
